import React, { useEffect } from 'react';
import { Switch, Route, Redirect } from "react-router-dom";
import Index from './pages/Index/Index';
import Detail from './pages/Detail/Detail';
import ErrorPage from './pages/Error/Error';
import { RouteProps } from 'react-router';

const Root: React.FC<RouteProps> = (props) => {
    useEffect(() => {
        // window.AnalyticsSDK.trackPageView();
        console.log('====trackPageView====')
    }, [props.location]);
    return (
        <Switch>
            <Route path="/404" component={ErrorPage} exact />
            <Route path="/detail/" component={Detail} exact />
            <Route path="/" component={Index} exact />
            <Redirect from="*" to="/404" />
        </Switch>)
};
export default Root;
